import axios from 'axios';

import {ROOT_URL} from '../../actions';
import { toast } from 'react-toastify';

export const FETCH_SENTENCE_START = 'fetch_sentence_start';
export const FETCH_SENTENCE_ERROR = 'fetch_sentence_error';
export const FETCH_SENTENCE_SUCCESS = 'fetch_sentence_success';

export const FETCH_AUTO_SENTENCE_START = 'fetch_auto_sentence_start';
export const FETCH_AUTO_SENTENCE_ERROR = 'fetch_auto_sentence_error';
export const FETCH_AUTO_SENTENCE_SUCCESS = 'fetch_auto_sentence_success';

export const CREATE_SENTENCE_START = 'create_sentence_start';
export const CREATE_SENTENCE_ERROR = 'create_sentence_error';
export const CREATE_SENTENCE_SUCCESS = 'create_sentence_success';

export const UPDATE_SENTENCE_START = 'update_sentence_start';
export const UPDATE_SENTENCE_ERROR = 'update_sentence_error';
export const UPDATE_SENTENCE_SUCCESS = 'update_sentence_success';

export function fetchSentence(id) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('jwt');
  const request = axios.get(`${ROOT_URL}/brands-sentences?brand=${id}`);
  return (dispatch) => {
    dispatch({ type: FETCH_SENTENCE_START });
    request.then((data) => {
      dispatch({ type: FETCH_SENTENCE_SUCCESS, payload: data });
    }).catch((error) => {
      dispatch({ type: FETCH_SENTENCE_ERROR, error });
      toast.error(`Error: fetching sentence: ${error.message}`);
    });
  };
}

export function createSentence(values) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('jwt');
  const request = axios.post(`${ROOT_URL}/brands-sentences`, values);
  return (dispatch) => {
    dispatch({ type: CREATE_SENTENCE_START });
    request.then((data) => {
      dispatch({ type: CREATE_SENTENCE_SUCCESS, payload: data });
      toast.success("Sentence created correclty");
    }).catch((error) => {
      dispatch({ type: CREATE_SENTENCE_ERROR, error });
      toast.error(`Error: creating sentence: ${error.message}`);
    });
  };
}

export function updateSentence(sentenceId, values) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('jwt');
  const request = axios.patch(`${ROOT_URL}/brands-sentences/${sentenceId}`, values);
  return (dispatch) => {
    dispatch({ type: UPDATE_SENTENCE_START });
    request.then((data) => {
      dispatch({ type: UPDATE_SENTENCE_SUCCESS, payload: data });
      toast.success("Sentence updated correclty");
    }).catch((error) => {
      dispatch({ type: UPDATE_SENTENCE_ERROR, error });
      toast.error(`Error: updating sentence: ${error.message}`);
    });
  };
}

export function fetchAutoSentence(id) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('jwt');
  const request = axios.get(`${ROOT_URL}/brands-sentences?brand=${id}&system_generated=true`);
  return (dispatch) => {
    dispatch({ type: FETCH_AUTO_SENTENCE_START });
    request.then((data) => {
      dispatch({ type: FETCH_AUTO_SENTENCE_SUCCESS, payload: data });
    }).catch((error) => {
      dispatch({ type: FETCH_AUTO_SENTENCE_ERROR, error });
      toast.error(`Error: fetching Auto Sentence: ${error.message}`);
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/sentence/index.js